import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaEnvelope, FaPhone } from 'react-icons/fa';
import { FaFacebook, FaFacebookF, FaLinkedin, FaLinkedinIn } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className=" bg-gray-900 text-gray-300 py-10 px-6 ">
      <div className=" flex  flex-wrap justify-between sm:grid-cols-1 md:grid-cols-2  lg:px-16 sm:px-4 md:px-4  ">
        {/* Logo & About */}
        <div>
          <img height={70} width={250} src="/cLogo.png" alt="" />
          <p className="mt-2 text-gray-400">Empowering businesses with cutting-edge technology solutions.</p>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="text-xl font-semibold text-white mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/" className="hover:text-blue-500">Home</Link></li>
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/webTechnology" className="hover:text-blue-500">WebTechnology</Link></li>
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/regulation" className="hover:text-blue-500">Regulations</Link></li>
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/about" className="hover:text-blue-500">About</Link></li>
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/pricing" className="hover:text-blue-500">Pricing</Link></li>
            <li><Link onClick={() => {
              window.scroll(0, 0)
            }} to="/contact" className="hover:text-blue-500">Contact</Link></li>
          </ul>
        </div>

        {/* Contact & Social Links */}
        <div>
          <h3 className="text-2xl font-semibold text-white mb-4">Get in Touch</h3>
          <ul className=" flex flex-row items-center gap-1">
            

            <li className="flex items-center justify-center md:justify-start">
              <a href="https://www.instagram.com/infyst_tech?igsh=MWF4YXhvdHAzZG41YQ==" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
                <div className='  text-white p-2 rounded-full'>
                  <img src="/insta.svg" alt="" className=' h-8 w-8' />
                </div></a>
            </li>

            <li className="flex items-center justify-center md:justify-start ">
              <a href="https://www.facebook.com/share/1FmXEAnnkK/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
                <div className='  text-white p-2 rounded-full'>
                  <img src="/facebook.svg" alt="" className=' h-8 w-8' />
                </div></a>
            </li>

            <li className="flex items-center justify-center md:justify-start ">
              <a href="https://www.facebook.com/share/1FmXEAnnkK/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
                <div className='  text-white p-2 rounded-full'>
                  <img src="/linked.svg" alt="" className=' h-8 w-8' />
                </div></a>
            </li>

            
          </ul>
          <ul>
          <li className="flex items-center justify-center md:justify-start ">
          <div className='  text-white p-2 rounded-full'>
                  <img src="/email.svg" alt="" className=' h-8 w-8' />
                </div>
              <a href="mailto:info@infyst.in" className="hover:text-blue-500">
              info@infyst.in
              </a>
            </li>

            <li className="flex items-center justify-center -mt-4 md:justify-start ">
            <div className='  text-white p-2 rounded-full'>
                  <img src="/phone.svg" alt="" className=' h-8 w-8' />
                </div>
              <a href="tel:+917019291371" className="hover:text-blue-500">
              +917019291371
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-10 border-t border-gray-700 pt-4 text-center text-sm">
        <p>&copy; {new Date().getFullYear()} Infyst Tech. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
